import React, { useContext, useEffect, useState } from "react"
import { Link } from "react-router-dom"
import {
  Col,
  Container,
  Row,
  Label,
  Table,
  Card,
  CardBody,
  Spinner,
  UncontrolledTooltip,
  Button,
} from "reactstrap"
import config from "config/config"
import Breadcrumbs from "components/Common/Breadcrumb"
import CreateCircular from "./addCircular"
import { CircularApi } from "apis/CircularAPI"
import { classGroupApi } from "apis/ClassGroupApi"
import { Modal, ModalHeader, ModalBody } from "reactstrap"
import Swal from "sweetalert2"
import Loading from "components/Loading"
import Pagination from "react-js-pagination"
import { SessionContext } from "context/sessionContext"

const Circular = () => {
  document.title = "Circular"
  const { Session } = useContext(SessionContext)

  let session = Session || sessionStorage.getItem("SessionId")

  const [CurrentPage, setCurrentPage] = useState(1)
  const [Page, setPage] = useState(1)
  const resultPerPage = 10
  const [circularList, setCircularList] = useState([])
  const [loader, setLoader] = useState()
  const [modalOpen, setModalOpen] = useState(false)
  const [modalClasses, setModalClasses] = useState([])
  const [modalTitle, setModalTitle] = useState("")
  const [fileModalOpen, setFileModalOpen] = useState(false)
  const [selectedFilesList, setSelectedFilesList] = useState([])
  const [fileModalTitle, setFileModalTitle] = useState("")

  useEffect(() => {
    if (!circularList || circularList.length === 0) {
      setLoader(<Loading />)
    }
    const currentSession = Session || sessionStorage.getItem("SessionId") || session
    let data = {
      session_id: currentSession,
      resultPerPage: CurrentPage,
    }
    CircularApi.getCircular(data)
      .then(res => {
        if (res.data.status === 200) {
          setLoader("")
        }
        setCircularList(res.data.circular)
        setPage(res.data.circular_count)
      })
      .catch(err => console.log(err))
  }, [CurrentPage, session, Session])

  const onDelete = id => {
    let cid = {
      circular_id: id,
    }
    Swal.fire({
      title: "Are you sure?",
      text: "You will not be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#f46a6a",
      confirmButtonText: "Yes, delete it!",
    }).then(result => {
      if (result.isConfirmed) {
        CircularApi.deleteCircular(cid).then(res => {
          Swal.fire("Deleted!", res.data.msg, "success")
          window.location.href = "/circular"
        })
      }
    })
  }

  function convertDate(data) {
    const dateString = data
    const date = new Date(dateString)
    const formattedDate = date.toLocaleDateString("en-IN", {
      day: "numeric",
      month: "long",
      year: "numeric",
    })
    const formattedTime = date.toLocaleTimeString("en-IN", {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    })
    return `${formattedDate}, ${formattedTime}`
  }

  function convertDateOnly(data) {
    if (!data) return "-"
    const date = new Date(data)
    if (isNaN(date.getTime())) return "-"
    return date.toLocaleDateString("en-IN", {
      day: "numeric",
      month: "long",
      year: "numeric",
    })
  }

  const convertStr = val => {
    if (!val) return ""
    try {
      const arr = typeof val === "string" ? JSON.parse(val) : val
      if (!Array.isArray(arr)) return ""
      return arr
        .map(item => (item && item.label ? item.label.toUpperCase() : ""))
        .filter(Boolean)
        .join(", ")
    } catch (e) {
      return ""
    }
  }

  const convertStrTo = val => {
    if (!val) return ""
    try {
      const arr = typeof val === "string" ? JSON.parse(val) : val
      if (!Array.isArray(arr)) return ""
      return arr
        .map(item => (item && item.label ? item.label.toUpperCase() : ""))
        .filter(Boolean)
        .join(", ")
    } catch (e) {
      return ""
    }
  }


  const openModal = cir => {
    setModalTitle(cir.title || "Classes")
    // if st_class exists as JSON of options
    if (cir.st_class) {
      try {
        const classes = JSON.parse(cir.st_class)
        setModalClasses(classes)
        setModalOpen(true)
        return
      } catch (e) {
        // ignore
      }
    }
    // if groupofclass_ids present, fetch groups and expand
    if (cir.groupofclass_ids) {
      try {
        const ids = JSON.parse(cir.groupofclass_ids)
        classGroupApi
          .getClassGroup()
          .then(res => {
            const groups =
              res.data && res.data.grupofclass ? res.data.grupofclass : []
            const classes = []
            ids.forEach(id => {
              const g = groups.find(x => Number(x.id) === Number(id))
              if (g) {
                try {
                  const st = JSON.parse(g.st_class)
                  st.forEach(s => classes.push(s))
                } catch (e) {
                  // ignore
                }
              }
            })
            setModalClasses(classes)
            setModalOpen(true)
          })
          .catch(e => {
            console.log(e)
            setModalClasses([])
            setModalOpen(true)
          })
      } catch (e) {
        console.log(e)
      }
    }
  }

  const parseCircularFiles = cir => {
    if (!cir) return []

    // 1. Check numbered fields: notice_file_1, notice_file_2, notice_file_3, notice_file_4 (and notice_file1, notice_file2...)
    const numberedFiles = []
    for (let i = 1; i <= 10; i++) {
      const val = cir[`notice_file_${i}`] || cir[`notice_file${i}`]
      if (val) {
        if (typeof val === "string" && val.trim()) {
          numberedFiles.push(val.trim())
        } else if (typeof val === "object" && val !== null) {
          const fileStr =
            val.file || val.notice_file || val.url || val.path || val.name || ""
          if (fileStr) numberedFiles.push(fileStr)
        }
      }
    }
    if (numberedFiles.length > 0) {
      return numberedFiles
    }

    // 2. Check array fields
    const arrayFields = [cir.notice_files, cir.files, cir.circular_files, cir.pdf_files]
    for (const arr of arrayFields) {
      if (Array.isArray(arr) && arr.length > 0) {
        return arr
          .map(item => {
            if (typeof item === "string") return item
            if (typeof item === "object" && item !== null) {
              return item.file || item.notice_file || item.url || item.path || item.name || ""
            }
            return ""
          })
          .filter(Boolean)
      }
    }

    // 2. Check notice_file
    const fileVal = cir.notice_file
    if (!fileVal) return []

    if (Array.isArray(fileVal)) {
      return fileVal
        .map(item => {
          if (typeof item === "string") return item
          if (typeof item === "object" && item !== null) {
            return item.file || item.url || item.path || item.name || ""
          }
          return ""
        })
        .filter(Boolean)
    }

    if (typeof fileVal === "string") {
      const trimmed = fileVal.trim()
      if (!trimmed) return []

      if (
        (trimmed.startsWith("[") && trimmed.endsWith("]")) ||
        (trimmed.startsWith("{") && trimmed.endsWith("}"))
      ) {
        try {
          const parsed = JSON.parse(trimmed)
          if (Array.isArray(parsed)) {
            return parsed
              .map(item => {
                if (typeof item === "string") return item
                if (typeof item === "object" && item !== null) {
                  return item.file || item.url || item.path || item.name || ""
                }
                return ""
              })
              .filter(Boolean)
          }
          if (typeof parsed === "string") {
            return [parsed]
          }
        } catch (e) {
          // ignore error
        }
      }

      if (trimmed.includes(",")) {
        return trimmed.split(",").map(f => f.trim()).filter(Boolean)
      }

      return [trimmed]
    }

    return []
  }

  const getFileUrl = filePath => {
    if (!filePath) return ""
    const pathStr =
      typeof filePath === "object" && filePath !== null
        ? filePath.url || filePath.file || filePath.path || ""
        : filePath
    if (!pathStr || typeof pathStr !== "string") return ""
    if (
      pathStr.startsWith("http://") ||
      pathStr.startsWith("https://") ||
      pathStr.startsWith("blob:") ||
      pathStr.startsWith("data:")
    ) {
      return pathStr
    }
    const cleanPath = pathStr.startsWith("/") ? pathStr.slice(1) : pathStr
    return `${config.BaseImageUrl}/${cleanPath}`
  }

  const getFileName = (filePath, index) => {
    if (!filePath) return `Document ${index !== undefined ? index + 1 : 1}`
    if (typeof filePath === "object" && filePath !== null && filePath.file_name) {
      return filePath.file_name
    }
    const pathStr =
      typeof filePath === "object" && filePath !== null
        ? filePath.url || filePath.file || filePath.path || ""
        : filePath
    if (!pathStr || typeof pathStr !== "string") {
      return `Document ${index !== undefined ? index + 1 : 1}`
    }
    try {
      const clean = pathStr.split("?")[0].split("#")[0]
      const parts = clean.split("/")
      const name = parts[parts.length - 1]
      return (
        decodeURIComponent(name) ||
        `Document ${index !== undefined ? index + 1 : 1}`
      )
    } catch (e) {
      return `Document ${index !== undefined ? index + 1 : 1}`
    }
  }


  const openFileModal = (cir, files) => {
    setFileModalTitle(cir.title || "Circular Files")
    setSelectedFilesList(files)
    setFileModalOpen(true)
  }

  return (
    <div className="page-content">
      <Container fluid>
        {/* Render Breadcrumb */}
        <Breadcrumbs title="" breadcrumbItem="Circular" />

        <Col xl="12" sm="12" className="mx-auto mb-1">
          <Row>
            <Card className="bg-transparent shadow-none pt-0">
              <CardBody className="p-0 text-end">
                <Link to="/add-circular">
                  <Button
                    color="primary"
                    className="btn btn-primary waves-effect waves-light"
                  >
                    <i className="bx bxs-add-to-queue p-1"></i>
                    Create Circular
                  </Button>
                </Link>
              </CardBody>
            </Card>
          </Row>
        </Col>
        <Col xl="12" sm="12" className="mx-auto mb-4">
          <Card className="shadow-none">
            <CardBody>
              <Row>
                {loader ? <div>{loader}</div> : null}
                {!circularList || circularList.length === 0
                  ? !loader && (
                      <Card className="shadow-none">
                        <div
                          style={{ height: "310px" }}
                          className="align-center text-center"
                        >
                          <h2 className="text-primary mt-5 ">
                            Circular Not Found !
                          </h2>
                        </div>
                      </Card>
                    )
                  : !loader && (
                      <div className="table-responsive">
                        <Table className="table table-striped">
                          <thead>
                            <tr>
                              <th className="text-center">Sr No</th>
                              <th className="text-center">Title</th>
                              <th>Posted Date</th>
                              <th>Expiry Date</th>
                              <th>Class</th>
                              <th>Sent To</th>
                              <th>File</th>
                              <th>Action</th>
                            </tr>
                          </thead>
                          <tbody>
                            {circularList &&
                              circularList.map((cir, index) => (
                                <tr key={index}>
                                  <th scope="row" className="text-center">
                                    {(CurrentPage - 1) * 10 + index + 1}
                                  </th>
                                  <td className="text-start font-weight-bold">
                                    {cir.title.toUpperCase()}
                                  </td>
                                  <td> {convertDate(cir.notice_date)}</td>
                                  <td>{convertDateOnly(cir.circular_end_date)}</td>
                                  <td>
                                    {cir.groupofclass &&
                                    cir.groupofclass.length > 0
                                      ? cir.groupofclass.join(", ")
                                      : cir.st_class
                                      ? convertStr(cir.st_class)
                                      : "-"}
                                  <i
                                    className="mdi mdi-eye ms-2 cursor-pointer text-primary"
                                    onClick={() => openModal(cir)}
                                    title="View classes"
                                  />
                                </td>
                                <td>
                                  {convertStrTo(cir.send_by)}
                                  {/* {JSON.parse(cir.send_by).map(
                                    (item, i) => item.label.toUpperCase() + ", "
                                  )} */}
                                </td>
                                <td>
                                  {(() => {
                                    const files = parseCircularFiles(cir)
                                    if (files.length > 0) {
                                      return (
                                        <span
                                          className="cursor-pointer text-primary d-inline-flex align-items-center"
                                          onClick={() => openFileModal(cir, files)}
                                          title={`View ${files.length} uploaded ${files.length === 1 ? "file" : "files"}`}
                                          style={{ cursor: "pointer" }}
                                        >
                                          <i
                                            className="mdi mdi-eye font-size-18 text-primary"
                                            id={`file-view-${index}`}
                                          />
                                          {files.length > 0 && (
                                            <span
                                              className="badge rounded-pill bg-primary ms-1"
                                              style={{ fontSize: "10px" }}
                                            >
                                              {files.length}
                                            </span>
                                          )}
                                        </span>
                                      )
                                    }
                                    return (
                                      <span className="text-muted" title="No file attached">
                                        <i className="bx bx-file-blank font-size-18 text-warning" />
                                      </span>
                                    )
                                  })()}
                                </td>
                                <td>
                                  <div className="d-flex gap-3">
                                    <Link
                                      to={`/edit-circular/${cir.id}`}
                                      className="text-success"
                                    >
                                      <i
                                        className="mdi mdi-pencil font-size-18"
                                        id="edittooltip"
                                      />
                                    </Link>
                                    <Link
                                      to="#"
                                      className="text-danger"
                                      onClick={() => {
                                        onDelete(cir.id)
                                      }}
                                    >
                                      <i
                                        className="mdi mdi-delete font-size-18"
                                        id="deletetooltip"
                                      />
                                    </Link>
                                  </div>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </Table>
                        <Modal
                          isOpen={modalOpen}
                          toggle={() => setModalOpen(!modalOpen)}
                          size="lg"
                        >
                          <ModalHeader toggle={() => setModalOpen(false)}>
                            {modalTitle}
                          </ModalHeader>
                          <ModalBody>
                            <ul>
                              {modalClasses &&
                                modalClasses.map((c, i) => (
                                  <li key={i}>{c.label ? c.label : c}</li>
                                ))}
                            </ul>
                          </ModalBody>
                        </Modal>

                        {/* Modal to view and download uploaded PDFs */}
                        <Modal
                          isOpen={fileModalOpen}
                          toggle={() => setFileModalOpen(!fileModalOpen)}
                          size="md"
                          centered
                        >
                          <ModalHeader toggle={() => setFileModalOpen(false)}>
                            Uploaded Files - {fileModalTitle.toUpperCase()}
                          </ModalHeader>
                          <ModalBody>
                            {selectedFilesList.length === 0 ? (
                              <div className="text-center py-4 text-muted">
                                <i className="bx bx-file-blank font-size-24 text-warning d-block mb-2" />
                                No files uploaded.
                              </div>
                            ) : (
                              <div className="table-responsive">
                                <Table className="table align-middle table-nowrap mb-0">
                                  <thead className="table-light">
                                    <tr>
                                      <th style={{ width: "50px" }} className="text-center">#</th>
                                      <th>File Name</th>
                                      <th className="text-end" style={{ width: "100px" }}>Action</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {selectedFilesList.map((file, idx) => {
                                      const fullUrl = getFileUrl(file)
                                      const fileName = getFileName(file, idx)
                                      const fileStr = (
                                        typeof file === "string"
                                          ? file
                                          : (file && (file.file_name || file.url || "")) || ""
                                      ).toLowerCase()
                                      const isPdf =
                                        fileStr.endsWith(".pdf") ||
                                        fileStr.includes(".pdf") ||
                                        fileName.toLowerCase().endsWith(".pdf")
                                      return (
                                        <tr key={idx}>
                                          <td className="text-center font-weight-bold text-muted">
                                            {idx + 1}
                                          </td>
                                          <td>
                                            <div className="d-flex align-items-center">
                                              {isPdf ? (
                                                <i className="mdi mdi-file-pdf-outline text-danger font-size-22 me-2" />
                                              ) : (
                                                <i className="mdi mdi-file-image-outline text-success font-size-22 me-2" />
                                              )}
                                              <span
                                                className="text-truncate d-inline-block"
                                                style={{ maxWidth: "200px" }}
                                                title={fileName}
                                              >
                                                {fileName}
                                              </span>
                                            </div>
                                          </td>
                                          <td className="text-end">
                                            <div className="d-flex justify-content-end gap-2">
                                              <a
                                                href={fullUrl}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="btn btn-sm btn-outline-primary waves-effect"
                                                title="View file in new tab"
                                              >
                                                <i className="mdi mdi-eye-outline me-1" />
                                                View
                                              </a>
                                            </div>
                                          </td>
                                        </tr>
                                      )
                                    })}
                                  </tbody>
                                </Table>
                              </div>
                            )}
                          </ModalBody>
                        </Modal>

                      </div>
                    )}
              </Row>
              <div className="col-12">
                <nav
                  style={{ backgroundColor: "transparent", borderRadius: 10 }}
                >
                  {!circularList || circularList.length === 0 ? (
                    ""
                  ) : (
                    <ul className="pagination justify-content-center">
                      {Page && (
                        <Pagination
                          activePage={CurrentPage}
                          itemsCountPerPage={resultPerPage}
                          totalItemsCount={Page}
                          // totalItemsCount={
                          //   filteredProducts && productCount ? productCount : 0
                          // }
                          hideFirstLastPages={true}
                          onChange={e => setCurrentPage(e)}
                          nextPageText="Next"
                          prevPageText="Previous"
                          lastPageText="Last"
                          firstPageText="1st"
                          itemClass="page-item"
                          linkClass="page-link"
                          activeClass="active"
                          activeLinkClass="active"
                          hideDisabled={true}
                        />
                      )}
                    </ul>
                  )}
                </nav>
              </div>
            </CardBody>
          </Card>
        </Col>
      </Container>
    </div>
  )
}

export default Circular
